import { Link } from 'react-router';
import { Box, Container, Typography, Card, CardContent, Stack } from '@mui/material';
import PsychologyIcon from '@mui/icons-material/Psychology';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

export function ServicesSection() {
  return (
    <Box sx={{ bgcolor: 'background.default', py: { xs: 8, md: 12 } }}>
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          sx={{
            textAlign: 'center',
            mb: 2,
            fontSize: { xs: '2rem', md: '2.5rem' },
          }}
        >
          Jak mohu pomoci
        </Typography>
        <Typography
          sx={{
            textAlign: 'center',
            color: 'text.secondary',
            fontSize: '1.1rem',
            mb: 8,
            maxWidth: 700,
            mx: 'auto',
          }}
        >
          Nabízím profesionální podporu v oblasti psychoterapie a etopedického poradenství
        </Typography>

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={5}
          sx={{ maxWidth: 1100, mx: 'auto' }}
        >
          {/* Psychoterapie */}
          <Card
            component={Link}
            to="/psychoterapie"
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              textDecoration: 'none',
              color: 'inherit',
              borderRadius: 3,
              transition: 'all 0.3s ease-in-out',
              '&:hover': {
                transform: 'translateY(-8px)',
                boxShadow: '0 12px 32px rgba(0, 0, 0, 0.12)',
              },
            }}
          >
            <CardContent sx={{ flexGrow: 1, p: 5, textAlign: 'center' }}>
              <Box
                sx={{
                  display: 'inline-flex',
                  p: 2,
                  borderRadius: '50%',
                  bgcolor: 'primary.light',
                  mb: 3,
                }}
              >
                <PsychologyIcon sx={{ fontSize: 40, color: 'primary.dark' }} />
              </Box>
              <Typography
                variant="h3"
                sx={{
                  mb: 3,
                  fontSize: '1.75rem',
                  fontWeight: 500,
                }}
              >
                Psychoterapie
              </Typography>
              <Typography
                paragraph
                sx={{
                  mb: 4,
                  lineHeight: 1.8,
                  color: 'text.secondary',
                  fontSize: '1.05rem',
                }}
              >
                Každý si neseme svůj příběh. Psychoterapie je proces, který umožňuje vidět
                vlastní příběh novým způsobem – s odstupem, nadhledem a hlubším pochopením souvislostí.
              </Typography>
              <Typography
                sx={{
                  color: 'primary.dark',
                  fontWeight: 600,
                  fontSize: '1.05rem',
                  transition: 'all 0.2s ease',
                  '.MuiCard-root:hover &': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Zjistit více →
              </Typography>
            </CardContent>
          </Card>

          {/* Etopedické poradenství */}
          <Card
            component={Link}
            to="/etopedicke-poradenstvi"
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              textDecoration: 'none',
              color: 'inherit',
              borderRadius: 3,
              transition: 'all 0.3s ease-in-out',
              '&:hover': {
                transform: 'translateY(-8px)',
                boxShadow: '0 12px 32px rgba(0, 0, 0, 0.12)',
              },
            }}
          >
            <CardContent sx={{ flexGrow: 1, p: 5, textAlign: 'center' }}>
              <Box
                sx={{
                  display: 'inline-flex',
                  p: 2,
                  borderRadius: '50%',
                  bgcolor: 'secondary.light',
                  mb: 3,
                }}
              >
                <FavoriteBorderIcon sx={{ fontSize: 40, color: 'secondary.dark' }} />
              </Box>
              <Typography
                variant="h3"
                sx={{
                  mb: 3,
                  fontSize: '1.75rem',
                  fontWeight: 500,
                }}
              >
                Etopedické poradenství
              </Typography>
              <Typography
                paragraph
                sx={{
                  mb: 4,
                  lineHeight: 1.8,
                  color: 'text.secondary',
                  fontSize: '1.05rem',
                }}
              >
                Praktická pomoc v situacích, kdy samotná terapie nestačí. Etopedie pomáhá pochopit,
                co chování vyjadřuje, a hledá způsoby, jak ho změnit.
              </Typography>
              <Typography
                sx={{
                  color: 'primary.dark',
                  fontWeight: 600,
                  fontSize: '1.05rem',
                  transition: 'all 0.2s ease',
                  '.MuiCard-root:hover &': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Zjistit více →
              </Typography>
            </CardContent>
          </Card>
        </Stack>
      </Container>
    </Box>
  );
}
